import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Select, message, Tabs, DatePicker, Checkbox, Tooltip, Modal, Image, Collapse } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Header } from "../../../../components";
import { GET } from "../../../../services/index";
import {
  UseFetchInputs,
  UseFetchCreateInput,
  UseFetchUpdateInput,
  UseFetchRejectCase,
  useFetchListInput,
  useFetchListInputReject,
} from "../hooks/useFetch";
import Table from "../components/Table";
import EditModal from "../components/EditModal";
import { useNewWorkSound } from "../../../../hooks/useNewWorkSound";
import RejectModal from "../components/RejectModal";
import SuccessModal from "../../../../components/SuccessModal";
import dayjs from "dayjs";
import {
  INPUT_CASE_REQUIRES_IMAGE,
  INPUT_CASE_TYPE_OPTIONS,
  JOB_TYPE,
  REGISTER_TASK,
} from "../../../../data/constant";
const { RangePicker } = DatePicker;


function InputPage() {
  const [form] = Form.useForm();
  // ติ๊ก "ไม่มี User" = เคสที่ไม่มี userId/เบอร์โทรให้อ้างอิง → ปิดช่อง User + ไม่บังคับกรอก
  // (admin ไปกรอกให้ทีหลังที่หน้าจัดการเคสได้)
  const noUser = Form.useWatch("noUser", form);
  const {
    data: inputs = [],
    isLoading,
    refetch: refetchInputs,
  } = useFetchListInputReject();
  const { mutateAsync: createInput, isLoading: isCreating } = UseFetchCreateInput();
  // กันเปิด confirm modal ซ้อน (กดปุ่ม "เพิ่ม" รัว ๆ ตอน validate/เช็ค blacklist ยังไม่เสร็จ → เบิ้ล)
  const isSubmittingRef = useRef(false);
  const { mutateAsync: updateInput, isLoading: isUpdating } = UseFetchUpdateInput();
  const { mutateAsync: rejectCase, isLoading: isRejecting } = UseFetchRejectCase();
  const { mutateAsync: listInput, isLoading: isListingInput } = useFetchListInput();
  const textareaRef = useRef(null);
  const [imageSrc, setImageSrc] = useState([]);
  const [imageSrcChoice, setImageSrcChoice] = useState([]);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  const [listInputData, setListInputData] = useState([]);

  // Edit modal states
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  // Reject modal states
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectingRecord, setRejectingRecord] = useState(null);

  // Search states for both tables
  const [myRejectCaseSearchText, setMyRejectCaseSearchText] = useState("");
  const [allRejectCaseSearchText, setAllRejectCaseSearchText] = useState("");
  const [allInformCaseSearchText, setAllInformCaseSearchText] = useState("");
  const [historySearchText, setHistorySearchText] = useState("");

  // Status filter states for both tables
  const [historyStatusFilter, setHistoryStatusFilter] = useState();

  // Case type filter states for both tables
  const [myRejectCaseNameFilter, setMyRejectCaseNameFilter] = useState();
  const [allRejectCaseNameFilter, setAllRejectCaseNameFilter] = useState();
  const [allInformCaseNameFilter, setAllInformCaseNameFilter] = useState();
  const [historyCaseNameFilter, setHistoryCaseNameFilter] = useState();
  const [historyDateFilter, setHistoryDateFilter] = useState([dayjs(), dayjs()]);

  const [checkBoxChecked, setCheckBoxChecked] = useState(true);
  const label = `${checkBoxChecked ? 'งานของฉัน' : 'งานทั้งหมด'}`;

  const onCheckboxChange = (e) => {
    setCheckBoxChecked(e.target.checked);
  };

  // แผง History ตั้งใจไม่ subscribe 'case:updated' (เหตุผลเดียวกับหน้า Case)
  // broadcast เป็นระดับบริษัท → ทุกเครื่อง refetch รายการทั้งวันพร้อมกัน
  // อยากได้สดทันที: กดปุ่ม Filter
  useEffect(() => {
    let intervalId;

    handleSearch(); // โหลดครั้งแรก

    if (checkBoxChecked) {
      intervalId = setInterval(handleSearch, 30000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [checkBoxChecked, historyDateFilter]);
  // Sync imageSrc with form field value for validation
  useEffect(() => {
    form.setFieldValue("images", imageSrc.length > 0 ? "has-images" : "");
  }, [imageSrc, form]);

  // Sync imageSrcChoice with form field value for validation
  useEffect(() => {
    form.setFieldValue(
      "imagesChoice",
      imageSrcChoice.length > 0 ? "has-images" : ""
    );
  }, [imageSrcChoice, form]);

  const userId = sessionStorage.getItem("id");
  const jobType = Number(sessionStorage.getItem("jobType"));

  const caseTypeSelectOptions = INPUT_CASE_TYPE_OPTIONS.map((opt) => (
    <Select.Option key={opt.value} value={opt.value}>
      {opt.label}
    </Select.Option>
  ));

  /** Marketing: ส่งเคสได้ ETC + Register เท่านั้น */
  const caseTypeSubmitOptions =
    jobType === JOB_TYPE.marketing
      ? INPUT_CASE_TYPE_OPTIONS.filter(
          (opt) => opt.value === "ETC" || opt.value === REGISTER_TASK
        ).map((opt) => (
          <Select.Option key={opt.value} value={opt.value}>
            {opt.label}
          </Select.Option>
        ))
      : caseTypeSelectOptions;
  const rejectedInputs = inputs.filter(
    (input) => input.status === "Reject" && input.reject_to == userId
  );
  // Reject ที่ไม่มีเจ้าของ (คนสร้างออฟไลน์ตอนโดน reject → backend ไม่เซ็ต reject_to) = pool กลาง
  // ต้องให้ "ทุกคนที่ใช้หน้านี้" เห็น ไม่ใช่แค่ marketing ไม่งั้นเคสหายสนิท:
  // ไม่โผล่ My Reject (reject_to = NULL) และแท็บนี้ก็ว่างตายตัว
  const allRejectedInputs = inputs.filter(
    (input) => input.status === "Reject" && input.reject_to == null
  );

  // ติ๊งเมื่อมีเคสถูกตีกลับมาหาเราเพิ่ม — เฉพาะ "ของฉัน" (reject_to = เรา) เท่านั้น
  // ไม่รวมกองกลางและไม่รวม Inform (Inform ไม่มีเจ้าของ เป็นกองกลางล้วน)
  // ใช้ rejectedInputs ตรง ๆ ไม่ใช่ตัวที่ผ่านช่องค้นหาแล้ว
  useNewWorkSound(isLoading ? null : rejectedInputs.length);

  // Inform = เคสถูกต้องแต่ข้อมูลไม่พอ → แยกแท็บออกจาก Reject
  // ไม่รวมกัน เพราะ inform ปิดไม่ได้ (ต้องเติมข้อมูลเท่านั้น) ถ้ากองรวมกับ reject
  // ที่ค้างสะสมอยู่หลักร้อย เคสที่ลูกค้ารออยู่จะจมหาย
  //
  // ไม่มีแนวคิด "ของฉัน" — เคส Inform เป็นกองกลางทั้งหมด ใครว่างก็หยิบไปเติมข้อมูลได้
  // จึงกรองด้วย status อย่างเดียว ไม่ดู inform_to (เคสเก่าที่เคยตั้งค่าไว้ก็ยังเห็น)
  const allInformedInputs = inputs.filter(
    (input) => input.status === "Inform"
  );

  // Filter functions for search
  const filterMyRejectCaseData = () => {
    let filteredData = rejectedInputs;

    // Filter by search text
    if (myRejectCaseSearchText) {
      const searchLower = myRejectCaseSearchText.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return (
          (item.caseName &&
            item.caseName.toLowerCase().includes(searchLower)) ||
          (item.note && item.note.toLowerCase().includes(searchLower)) ||
          (item.userId &&
            item.userId.toString().toLowerCase().includes(searchLower)) ||
          (item.status && item.status.toLowerCase().includes(searchLower))
        );
      });
    }

    // Filter by case type
    if (myRejectCaseNameFilter) {
      filteredData = filteredData.filter(
        (item) => item.caseName === myRejectCaseNameFilter
      );
    }

    return filteredData;
  };

  // ตัวกรองกลางของแท็บ Inform — ตรรกะเดียวกับ 2 ฟังก์ชันข้างบน
  // (ไม่ก๊อปเพิ่มอีก 2 ชุด เพราะจะกลายเป็น 4 ก้อนที่ต้องแก้พร้อมกันทุกครั้ง)
  const filterInformData = (source, searchText, caseNameFilter) => {
    let filteredData = source;
    if (searchText) {
      const searchLower = searchText.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          (item.caseName && item.caseName.toLowerCase().includes(searchLower)) ||
          (item.note && item.note.toLowerCase().includes(searchLower)) ||
          (item.userId &&
            item.userId.toString().toLowerCase().includes(searchLower))
      );
    }
    if (caseNameFilter) {
      filteredData = filteredData.filter(
        (item) => item.caseName === caseNameFilter
      );
    }
    return filteredData;
  };

  const filterAllInformCaseData = () =>
    filterInformData(allInformedInputs, allInformCaseSearchText, allInformCaseNameFilter);

  const filterAllRejectCaseData = () => {
    let filteredData = allRejectedInputs;

    // Filter by search text
    if (allRejectCaseSearchText) {
      const searchLower = allRejectCaseSearchText.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return (
          (item.caseName &&
            item.caseName.toLowerCase().includes(searchLower)) ||
          (item.note && item.note.toLowerCase().includes(searchLower)) ||
          (item.userId && item.userId.toString().toLowerCase().includes(searchLower)) ||
          (item.status && item.status.toLowerCase().includes(searchLower))
        );
      });
    }

    // Filter by case type
    if (allRejectCaseNameFilter) {
      filteredData = filteredData.filter(
        (item) => item.caseName === allRejectCaseNameFilter
      );
    }

    return filteredData;
  };


  const handleSubmit = async () => {
    if (isSubmittingRef.current) return; // กำลังเปิด/รอ modal อยู่ → กดซ้ำไม่เปิดอันใหม่
    isSubmittingRef.current = true;
    try {
      const values = await form.validateFields();

      // เคส "ไม่มี User" → ไม่มีอะไรให้เช็ค blacklist และห้ามยิง GET /blacklist/user/
      // (ถ้ายิงด้วยค่าว่างจะได้ URL ห้อย = ยิงมั่ว)
      const hasUser = !values.noUser && !!values.user;

      // ดึง blacklist ของ user ก่อนเปิด confirm (company scope จาก header ใน services)
      // best-effort: ถ้า error ก็ปล่อยส่งได้ปกติ (ไม่บล็อก)
      let userBlacklist = [];
      if (hasUser) {
        try {
          const { result } = await GET(`/api/v1/blacklist/user/${values.user}`);
          userBlacklist = result || [];
        } catch (e) {
          userBlacklist = [];
        }
      }

      Modal.confirm({
        title: "ยืนยันการสร้างข้อมูล",
        content: (
          <div className="mt-4" style={{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '8px' }}>
            <p>
              <strong>User ID:</strong>{" "}
              {hasUser ? values.user : <span style={{ color: "#fa8c16" }}>— ไม่มี User (กรอกทีหลัง) —</span>}
            </p>
            <p><strong>Case:</strong> {values.case}</p>
            {values.note && <p><strong>Note:</strong> {values.note}</p>}
            <p><strong>กรณีหลายเคส:</strong> {values.isMultiple ? "ใช่" : "ไม่ใช่"}</p>
            {userBlacklist.length > 0 && (
              <div style={{ margin: "8px 0", padding: "8px 12px", background: "#fff1f0", border: "1px solid #ffa39e", borderRadius: 6 }}>
                <div style={{ color: "#cf1322", fontWeight: "bold" }}>
                  ⚠️ User นี้ติด Blacklist {userBlacklist.length} รายการ
                </div>
                <Collapse ghost size="small" items={[{
                  key: "1",
                  label: "ดูรายละเอียด",
                  children: (
                    <div>
                      {userBlacklist.map((b) => (
                        <div key={b.id} style={{ borderBottom: "1px dashed #ffccc7", padding: "4px 0" }}>
                          <div style={{ fontWeight: 500, color: "#cf1322" }}>{b.topic_name || "-"}</div>
                          <div style={{ fontSize: 12 }}>ชื่อบัญชี: {b.account_name || "-"}</div>
                          <div style={{ fontSize: 12 }}>{b.bank || "-"} / {b.bank_account || "-"}</div>
                          {b.note && <div style={{ fontSize: 12, color: "#8c8c8c" }}>หมายเหตุ: {b.note}</div>}
                        </div>
                      ))}
                    </div>
                  ),
                }]} />
              </div>
            )}
            {imageSrc.length > 0 && (
              <div className="mt-2">
                <p><strong>รูปภาพหลักฐาน:</strong></p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "8px" }}>
                  <Image.PreviewGroup>
                    {imageSrc.map((src, index) => (
                      <Image key={`main-${index}`} src={src} alt="หลักฐาน" style={{ maxWidth: '100px', height: 'auto', borderRadius: '4px', objectFit: 'contain' }} />
                    ))}
                  </Image.PreviewGroup>
                </div>
              </div>
            )}
          </div>
        ),
        okText: "ยืนยัน",
        cancelText: "ยกเลิก",
        // ปลดล็อกเมื่อ modal ปิดสนิท (ทั้งกดยืนยัน/ยกเลิก) → พร้อมกดเพิ่มรอบใหม่ได้
        afterClose: () => { isSubmittingRef.current = false; },
        onOk: async () => {
          try {
            const formattedImages = imageSrc.map((image) =>
              image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            );

            const formattedImagesChoice = imageSrcChoice.map((image) =>
              image.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            );

            const formattedValues = {
              caseName: values.case,
              // ไม่มี User → ส่ง null (backend เก็บ NULL ไม่ใช่ '' — กัน join user_banks.phone ไปโดนแถวที่ phone ว่าง)
              userId: hasUser ? values.user : null,
              note: values.note,
              img: formattedImages,
              imgChoice: formattedImagesChoice,
              createBy: userId,
            };

            if (values.isMultiple) {
              const promises = formattedValues?.img.map((num) => {
                const payload = { ...formattedValues, img: [num] };
                return createInput(payload);
              });
              await Promise.all(promises);
            } else {
              await createInput(formattedValues);
            }
            handleSearch(20);
            setSuccessModalVisible(true);
          } catch (error) {
            console.error(error);
            message.error("ไม่สามารถสร้างข้อมูลได้ กรุณาลองอีกครั้ง");
          }
        },
      });
    } catch (error) {
      // validate fail → modal ไม่ได้เปิด (afterClose ไม่ทำงาน) ต้องปลดล็อกเอง
      isSubmittingRef.current = false;
      console.error("Validation failed:", error);
    }
  };

  const handleSuccessModalOk = () => {
    setSuccessModalVisible(false);
    form.resetFields();
    setImageSrc([]);
    setImageSrcChoice([]);
  };

  const handleDelete = (record) => {
    console.log("Delete input:", record);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setEditModalVisible(false);
    setEditingRecord(null);
  };

  const handleEditSubmit = async (formattedValues) => {
    try {
      await updateInput(formattedValues);
      message.success("อัพเดตข้อมูลสำเร็จ");
      setEditModalVisible(false);
      setEditingRecord(null);
      // mutateAsync รอจนบันทึกเสร็จจริงแล้ว → refetch ได้ทันที ไม่ต้องเดาเวลาด้วย setTimeout
      // (ของเดิมหน่วง 500ms ถ้าเซิร์ฟเวอร์ช้ากว่านั้นจะดึงข้อมูลเก่ากลับมา)
      refetchInputs();
    } catch (error) {
      message.error(
        error?.response?.data?.message || "ไม่สามารถอัพเดตข้อมูลได้"
      );
      // เคสถูกคนอื่นส่งกลับไปแล้ว → ปิดฟอร์มแล้วโหลดคิวใหม่ ให้แถวที่ค้างอยู่หายไปเลย
      setEditModalVisible(false);
      setEditingRecord(null);
      refetchInputs();
    }
  };

  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (const item of items) {
      if (item.type.indexOf("image") === 0) {
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrc([...imageSrc, e.target.result]);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleChoicePaste = (event) => {
    const items = event.clipboardData.items;
    for (const item of items) {
      if (item.type.indexOf("image") === 0) {
        const file = item.getAsFile();
        const reader = new FileReader();
        reader.onload = (e) => {
          setImageSrcChoice([...imageSrcChoice, e.target.result]);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleRejectCancel = (record) => {
    setRejectingRecord(record);
    setRejectModalVisible(true);
  };

  const handleRejectModalCancel = () => {
    setRejectModalVisible(false);
    setRejectingRecord(null);
  };

  const handleRejectSubmit = async (formattedValues) => {
    try {
      const payload = {
        caseId: rejectingRecord.id,
        // RejectModal ส่งเหตุผลมาในชื่อ rejectRemark — เดิมอ่าน cancelRemark ซึ่งไม่มีอยู่จริง เหตุผลเลยหายทุกครั้ง
        cancelRemark: formattedValues.rejectRemark,
        cancel_By: userId,
      };
      await rejectCase(payload);

      message.success("Reject/Cancel สำเร็จ");
      setRejectModalVisible(false);
      setRejectingRecord(null);
      refetchInputs();
    } catch (error) {
      message.error(
        error?.response?.data?.message || "ไม่สามารถ reject/cancel ได้"
      );
    }
  };

  const handleSearch = async (event, limit = 100) => {
    let startDate = historyDateFilter[0].format('YYYY-MM-DD');
    let endDate = historyDateFilter[1].format('YYYY-MM-DD');
    let payload = {};
    if (checkBoxChecked == true) {
      payload = {
        checkBoxcaseType: true,
        startDate,
        endDate,
        //limit: 50,
        fromInput: true
      };
    } else {
      payload = {
        startDate,
        endDate,
        status: historyStatusFilter,
        caseName: historyCaseNameFilter,
        search: historySearchText,
        limit: limit,
        checkBoxcaseType: false,
        fromInput: true
      };
    }
    const result = await listInput(payload);
    if (result?.result && result?.result.length > 0) {
      setListInputData(result?.result);
    } else setListInputData([]);
  };

  // แท็บ Inform ใช้โครงเดียวกัน 2 ตัว → ทำเป็นฟังก์ชันเดียว
  // สีป้ายจำนวนเคส: สีบอกประเภท (inform=ส้ม, reject=แดง) แต่ถ้าไม่มีของค้างเลยให้เทา
  // จะได้กวาดตาแท็บเดียวรู้ว่ามีงานรออยู่ตรงไหนบ้าง
  const badgeClass = (count, type) => {
    const bg = count > 0 ? (type === "inform" ? "bg-orange-500" : "bg-red-500") : "bg-gray-400";
    return `${bg} text-white rounded-full px-2 py-1 text-xs font-medium ml-1`;
  };

  const buildInformTab = (key, title, dataFn, searchText, setSearchText, nameFilter, setNameFilter) => ({
    key,
    label: (
      <span>
        {title}{" "}
        <span className={badgeClass(dataFn().length, "inform")}>{dataFn().length}</span>
      </span>
    ),
    children: (
      <div style={{ minWidth: 0, overflow: "hidden" }}>
        <div className="mb-4 flex gap-3 flex-col sm:flex-row">
          <Input
            placeholder="Filter"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            className="w-full sm:w-80"
          />
          <Select
            placeholder="Case Type"
            value={nameFilter}
            onChange={setNameFilter}
            allowClear
            className="w-full sm:w-32"
          >
            {caseTypeSelectOptions}
          </Select>
        </div>
        <div className="w-full overflow-x-auto" style={{ minWidth: 0, maxWidth: "100%" }}>
          <Table
            data={dataFn()}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onRejectCancel={handleRejectCancel}
            loading={isLoading}
            bordered
            scroll={{ x: "max-content" }}
          />
        </div>
      </div>
    ),
  });

  const items = [
    // Inform มาก่อน Reject เพราะปิดไม่ได้ = ต้องทำให้จบ ปล่อยค้างไม่ได้
    buildInformTab(
      "inform-all",
      "Inform",
      filterAllInformCaseData,
      allInformCaseSearchText,
      setAllInformCaseSearchText,
      allInformCaseNameFilter,
      setAllInformCaseNameFilter
    ),
    {
      key: "1",
      label: (
        <span>
          My Reject Case{" "}
          <span className={badgeClass(filterMyRejectCaseData().length, "reject")}>
            {filterMyRejectCaseData().length}
          </span>
        </span>
      ),
      children: (
        <div style={{ minWidth: 0, overflow: 'hidden' }}>
          <div className="mb-4 flex gap-3 flex-col sm:flex-row">
            <Input
              placeholder="Filter"
              value={myRejectCaseSearchText}
              onChange={(e) => setMyRejectCaseSearchText(e.target.value)}
              allowClear
              className="w-full sm:w-80"
            />
            <Select
              placeholder="Case Type"
              value={myRejectCaseNameFilter}
              onChange={setMyRejectCaseNameFilter}
              allowClear
              className="w-full sm:w-32"
            >
              {caseTypeSelectOptions}
            </Select>
          </div>
          <div className="w-full overflow-x-auto" style={{ minWidth: 0, maxWidth: '100%' }}>
            <Table
              data={filterMyRejectCaseData()}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onRejectCancel={handleRejectCancel}
              loading={isLoading}
              bordered
              scroll={{ x: 'max-content' }}
            />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <span>
          All Reject Case{" "}
          <span className={badgeClass(filterAllRejectCaseData().length, "reject")}>
            {filterAllRejectCaseData().length}
          </span>
        </span>
      ),
      children: (
        <div style={{ minWidth: 0, overflow: 'hidden' }}>
          <div className="mb-4 flex gap-3 flex-col sm:flex-row">
            <Input
              placeholder="Filter"
              value={allRejectCaseSearchText}
              onChange={(e) => setAllRejectCaseSearchText(e.target.value)}
              allowClear
              className="w-full sm:w-80"
            />
            <Select
              placeholder="Case Type"
              value={allRejectCaseNameFilter}
              onChange={setAllRejectCaseNameFilter}
              allowClear
              className="w-full sm:w-32"
            >
              {caseTypeSelectOptions}
            </Select>
          </div>
          <div className="w-full overflow-x-auto" style={{ minWidth: 0, maxWidth: '100%' }}>
            <Table
              data={filterAllRejectCaseData()}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onRejectCancel={handleRejectCancel}
              loading={isLoading}
              bordered
              scroll={{ x: 'max-content' }}
            />
          </div>
        </div>
      ),
    },
  ]


  return (
    <div className="md:m-5">
      <div className="flex flex-col lg:flex-row gap-6 border-4 border-black p-6 rounded-lg bg-gray-200">
        <div className="flex flex-col lg:flex-row gap-6 border-4 p-6 rounded-lg">
          <div className="w-full lg:w-[384px] flex-shrink-0">
            <Header category="App" title="Inputs" />
            <Form form={form} layout="vertical">
              <div className="flex gap-4">
                <Form.Item
                  name="user"
                  label="User"
                  rules={[{ required: !noUser, message: "Required" }]}
                  className="flex-1"
                  width="70%"
                >
                  <Input
                    maxLength={100}
                    placeholder={noUser ? "— ไม่มี User —" : "UserId"}
                    disabled={noUser}
                  />
                </Form.Item>

              </div>
              <Form.Item
                name="noUser"
                valuePropName="checked"
                initialValue={false}
              >
                <Checkbox
                  onChange={(e) => {
                    // ติ๊กแล้วล้างค่า + ล้าง error เดิมที่ค้างจากตอนที่ยังบังคับกรอก
                    if (e.target.checked) {
                      form.setFieldsValue({ user: undefined });
                      form.setFields([{ name: "user", errors: [] }]);
                    }
                  }}
                >
                  ไม่มี User{" "}
                  <span style={{ color: "#888" }}>
                    (เคสที่ไม่มี UserId/เบอร์โทร — ให้ admin กรอกทีหลังที่หน้าจัดการเคส)
                  </span>
                </Checkbox>
              </Form.Item>
              <Form.Item
                name="case"
                label="Case"
                rules={[{ required: true, message: "Please select case!" }]}
              >
                <Select>{caseTypeSubmitOptions}</Select>
              </Form.Item>

              <Form.Item
                name="isMultiple"
                valuePropName="checked"
                initialValue={false}
              >
                <Checkbox>
                  กรณีหลายเคส <span style={{ color: "red" }}> (ใส่รูปตามจำนวนเคสที่จะส่ง)</span>{" "}
                  <Tooltip
                    title={
                      <div>
                        <b>อัปเดตเมนูใหม่: ส่งหลายเคส</b>
                        <br /><br />

                        <div>สามารถส่งเคสหลายรายการพร้อมกัน</div>
                        <div>โดยอ้างอิงจากจำนวนรูป Receipt</div>

                        <br />

                        <div><b>เงื่อนไข</b></div>
                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                          <li>ใช้ได้เฉพาะ Case เดียวกัน</li>
                          <li>รองรับเฉพาะ Deposit / Withdraw</li>
                          <li>ต้องมีรูปอย่างน้อย 2 รูปขึ้นไป</li>
                        </ul>

                        <br />

                        <div><b>วิธีใช้งาน</b></div>
                        <ol style={{ paddingLeft: 16, margin: 0 }}>
                          <li>ติ๊กช่อง “กรณีหลายเคส”</li>
                          <li>ใส่รูป Receipt ตามจำนวนเคส</li>
                        </ol>

                        <br />

                        <div><b>ตัวอย่าง</b></div>
                        <div>Deposit ยูส 06500000</div>
                        <div>1) ฝาก 100 เวลา 01:55</div>
                        <div>2) ฝาก 500 เวลา 06:00</div>
                      </div>
                    }
                  >
                    <InfoCircleOutlined style={{ marginLeft: 6 }} />
                  </Tooltip>
                </Checkbox>
              </Form.Item>


              <Form.Item
                name="images"
                label="รูปภาพ(หลักฐาน)"
                dependencies={["case"]}
                rules={[
                  {
                    required: false,
                    validator: (_, value) => {
                      const caseValue = form.getFieldValue("case");
                      if (
                        INPUT_CASE_REQUIRES_IMAGE.includes(caseValue) &&
                        imageSrc.length === 0
                      ) {
                        return Promise.reject(
                          new Error("กรุณาอัพโหลดรูปภาพ Receipt สำหรับ Deposit")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <div>
                  <textarea
                    ref={textareaRef}
                    placeholder="กด Ctrl+V เพื่อวางรูป"
                    onPaste={handlePaste}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                    }}
                  />
                  {imageSrc.length > 0 && (
                    <>
                      <div className="mt-2 mb-1">
                        <strong>Preview รูป:</strong>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {imageSrc.map((src, index) => (
                          <div
                            key={index}
                            style={{ width: "100px", position: "relative" }}
                          >
                            <Button
                              type="text"
                              danger
                              style={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                                padding: 0,
                                minWidth: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                              }}
                              onClick={() => {
                                const newImageSrc = [...imageSrc];
                                newImageSrc.splice(index, 1);
                                setImageSrc(newImageSrc);
                              }}
                            >
                              ×
                            </Button>
                            <img
                              src={src}
                              alt="pasted"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </Form.Item>

              <Form.Item
                name="imagesChoice"
                label="รูปภาพ(เสริม)"
                required={false}
                style={{ display: "none" }}
              >
                <div>
                  <textarea
                    ref={textareaRef}
                    placeholder="กด Ctrl+V เพื่อวางรูป"
                    onPaste={handleChoicePaste}
                    rows={2}
                    style={{
                      width: "100%",
                      padding: "8px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "6px",
                      display: "none",
                    }}
                  />
                  {imageSrcChoice.length > 0 && (
                    <>
                      <div className="mt-2 mb-1">
                        <strong>Preview รูป:</strong>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {imageSrcChoice.map((src, index) => (
                          <div
                            key={index}
                            style={{ width: "100px", position: "relative" }}
                          >
                            <Button
                              type="text"
                              danger
                              style={{
                                position: "absolute",
                                top: -10,
                                right: -10,
                                padding: 0,
                                minWidth: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "white",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                              }}
                              onClick={() => {
                                const newImageSrc = [...imageSrcChoice];
                                newImageSrc.splice(index, 1);
                                setImageSrcChoice(newImageSrc);
                              }}
                            >
                              ×
                            </Button>
                            <img
                              src={src}
                              alt="pasted"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </Form.Item>

              <Form.Item name="note" label="Note">
                <Input.TextArea rows={4} placeholder="Enter Note" />
              </Form.Item>
              <Button
                type="primary"
                onClick={handleSubmit}
                loading={isCreating}
                block
              >
                เพิ่ม
              </Button>
            </Form>
          </div>
        </div>

        <div className="con flex-col gap-6" style={{ width: '100%', minWidth: 0, overflow: 'hidden' }}>
          <div className="w-full" style={{ minWidth: 0, overflow: 'hidden' }}>
            <Header category="App" title="เคสตีกลับ" />
            <Tabs
              defaultActiveKey="inform-all"
              items={items}
            />
          </div>
        </div>
      </div>
      <br />
      <Header category="App" title="History" />
      <div className="mb-4 flex gap-3">
        <RangePicker
          placeholder="Date"
          value={historyDateFilter}
          onChange={(date) => setHistoryDateFilter(date)}
          allowClear
          className="w-64"
          format="DD/MM/YYYY"
        />
        <Input
          placeholder="Search"
          value={historySearchText}
          onChange={(e) => setHistorySearchText(e.target.value)}
          allowClear
          className="w-32"
        />
        <Select
          placeholder="Status"
          value={historyStatusFilter}
          onChange={setHistoryStatusFilter}
          allowClear
          className="w-32"
        >
          <Select.Option value="Success">Success</Select.Option>
          <Select.Option value="Reject">Reject</Select.Option>
          <Select.Option value="Inform">Inform</Select.Option>
          <Select.Option value="Waiting">Waiting</Select.Option>
          <Select.Option value="Pending">Pending</Select.Option>
        </Select>
        <Select
          placeholder="Case Type"
          value={historyCaseNameFilter}
          onChange={setHistoryCaseNameFilter}
          allowClear
          className="w-32"
        >
          {caseTypeSelectOptions}
        </Select>
        <Checkbox checked={checkBoxChecked} onChange={onCheckboxChange}>

          <p style={{ marginTop: 4 }}>{label}</p>
        </Checkbox>

        <Button type="primary" onClick={handleSearch}>Search</Button>
      </div>
      <Table
        data={listInputData}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onRejectCancel={handleRejectCancel}
        loading={isListingInput}
        isHistory={true}
        bordered
        scroll={{ x: 'max-content' }}
        refetch={handleSearch}
      />

      <SuccessModal visible={successModalVisible} onOk={handleSuccessModalOk} />

      {/* Edit Modal */}
      <EditModal
        visible={editModalVisible}
        onCancel={handleEditModalCancel}
        onSubmit={handleEditSubmit}
        record={editingRecord}
        loading={isUpdating}
      />

      {/* Reject Modal */}
      <RejectModal
        visible={rejectModalVisible}
        onCancel={handleRejectModalCancel}
        onSubmit={handleRejectSubmit}
        record={rejectingRecord}
        loading={isRejecting}
      />
    </div>
  );
}

export default InputPage;
